<template>
  <div class="mb-2 -mt-44 w-full md:mb-0 text-primary md:-mt-32" id="sectionP">
    <div class="flex flex-col justify-between items-center">
      <div class="flex relative flex-col justify-center items-center w-full">
        <div class="absolute opacity-30 text-primary text-muted">
          <svg height="150px" class="opacity-50 fill-current" version="1.1" viewBox="0 0 249 271" width="249px"
               xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title/>
            <desc/>
            <defs>
              <path
                d="M77.2338867,0 L77.2338867,6.6796875 C67.9564966,8.25684382 61.114524,11.7126198 56.7077637,17.0471191 C52.3010034,22.3816185 50.0976562,28.0639347 50.0976562,34.0942383 C50.0976562,40.4956375 51.1645401,48.4276871 53.2983398,57.890625 C55.6176874,68.0029802 56.7773438,76.4916649 56.7773438,83.3569336 C56.7773438,90.9643935 54.643576,98.2934218 50.3759766,105.344238 C46.1083771,112.395055 41.0522753,117.752667 35.2075195,121.417236 C29.3627637,125.081805 21.4307142,128.352036 11.4111328,131.228027 C28.6670785,136.51614 40.588346,143.682816 47.175293,152.728271 C53.76224,161.773727 57.0556641,170.749467 57.0556641,179.655762 C57.0556641,185.036648 55.9423939,192.643994 53.7158203,202.478027 C51.3964728,212.312061 50.2368164,220.615201 50.2368164,227.387695 C50.2368164,243.530354 59.2357499,253.178695 77.2338867,256.333008 L77.2338867,263.012695 C68.9770095,263.012695 62.2741957,262.409674 57.1252441,261.203613 C51.9762926,259.997553 46.2475901,257.191184 39.9389648,252.784424 C33.6303396,248.377664 28.6902034,242.880892 25.1184082,236.293945 C21.546613,229.706998 19.7607422,223.027378 19.7607422,216.254883 C19.7607422,210.039031 21.1987161,201.040098 24.074707,189.257812 C26.2085068,180.444292 27.2753906,172.836946 27.2753906,166.435547 C27.2753906,149.179601 18.1836847,138.974625 0,135.820312 L0,127.053223 C9.74125964,125.56884 16.722391,121.672395 20.9436035,115.36377 C25.164816,109.055144 27.2753906,102.329137 27.2753906,95.1855469 C27.2753906,88.8769216 26.254893,81.5942796 24.2138672,73.3374023 C21.3378762,61.6478908 19.8999023,52.9272749 19.8999023,47.175293 C19.8999023,35.9496509 24.7936522,25.3503917 34.5812988,15.3771973 C44.3689454,5.40400287 58.5863325,0.278321704 77.2338867,0 L77.2338867,0 Z"
                id="path-1"/>
              <filter filterUnits="objectBoundingBox" height="200%" id="filter-2" width="200%" x="-50%" y="-50%">
                <feOffset dx="0" dy="4" in="SourceAlpha" result="shadowOffsetOuter1"/>
                <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="2"/>
                <feColorMatrix in="shadowBlurOuter1" type="matrix"
                               values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0"/>
              </filter>
              <path
                d="M163,0 L163,6.6796875 C172.27739,8.25684382 179.119363,11.7126198 183.526123,17.0471191 C187.932883,22.3816185 190.13623,28.0639347 190.13623,34.0942383 C190.13623,40.4956375 189.069347,48.4276871 186.935547,57.890625 C184.616199,68.0029802 183.456543,76.4916649 183.456543,83.3569336 C183.456543,90.9643935 185.590311,98.2934218 189.85791,105.344238 C194.12551,112.395055 199.181611,117.752667 205.026367,121.417236 C210.871123,125.081805 218.803173,128.352036 228.822754,131.228027 C211.566808,136.51614 199.645541,143.682816 193.058594,152.728271 C186.471647,161.773727 183.178223,170.749467 183.178223,179.655762 C183.178223,185.036648 184.291493,192.643994 186.518066,202.478027 C188.837414,212.312061 189.99707,220.615201 189.99707,227.387695 C189.99707,243.530354 180.998137,253.178695 163,256.333008 L163,263.012695 C171.256877,263.012695 177.959691,262.409674 183.108643,261.203613 C188.257594,259.997553 193.986297,257.191184 200.294922,252.784424 C206.603547,248.377664 211.543683,242.880892 215.115479,236.293945 C218.687274,229.706998 220.473145,223.027378 220.473145,216.254883 C220.473145,210.039031 219.035171,201.040098 216.15918,189.257812 C214.02538,180.444292 212.958496,172.836946 212.958496,166.435547 C212.958496,149.179601 222.050202,138.974625 240.233887,135.820312 L240.233887,127.053223 C230.492627,125.56884 223.511496,121.672395 219.290283,115.36377 C215.069071,109.055144 212.958496,102.329137 212.958496,95.1855469 C212.958496,88.8769216 213.978994,81.5942796 216.02002,73.3374023 C218.89601,61.6478908 220.333984,52.9272749 220.333984,47.175293 C220.333984,35.9496509 215.440234,25.3503917 205.652588,15.3771973 C195.864941,5.40400287 181.647554,0.278321704 163,0 L163,0 Z"
                id="path-3"/>
              <filter filterUnits="objectBoundingBox" height="200%" id="filter-4" width="200%" x="-50%" y="-50%">
                <feOffset dx="0" dy="4" in="SourceAlpha" result="shadowOffsetOuter1"/>
                <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="2"/>
                <feColorMatrix in="shadowBlurOuter1" type="matrix"
                               values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0"/>
              </filter>
            </defs>
            <g fill="none" fill-rule="evenodd" id="Page-1" stroke="none" stroke-width="1">
              <g id="curly_braces" transform="translate(4.000000, 0.000000)">
                <g id="Combined-Shape">
                  <use fill="black" fill-opacity="1" filter="url(#filter-2)" xlink:href="#path-1"/>
                  <use fill="#697F9B" fill-rule="evenodd" xlink:href="#path-1"/>
                </g>
                <g id="Combined-Shape">
                  <use fill="black" fill-opacity="1" filter="url(#filter-4)" xlink:href="#path-3"/>
                  <use fill="#697F9B" fill-rule="evenodd" xlink:href="#path-3"/>
                </g>
              </g>
            </g>
          </svg>
        </div>
        <div class="flex justify-center items-center uppercase text-primary">
          <h1 class="absolute top-0 text-2xl font-bold tracking-wide lg:text-3xl">Projects</h1>
        </div>
        <div class="mt-14">
          <h6 class="text-xl font-bold tracking-wide lg:text-2xl">Some Of My Recent Works</h6>
        </div>
        <div class="flex relative flex-row justify-between items-center w-full">
          <div class="flex relative top-36 justify-center items-center w-1/2 opacity-30">
            <span
              class="absolute bg-secondary -z-10 w-40 ring-4 ring-muted h-80 rounded-r-full -left-10 animate-pulse border-1.5 border-l-0 shadow-cst_lg border-muted"></span>
          </div>
          <div class="flex relative justify-between items-center w-1/2 opacity-30">
            <div class="absolute right-0 justify-end items-center mt-32 -z-10">
              <span
                class="transform rotate-90 animate-pulse top-8 right-6 w-8 h-6 bg-primary border-1.5 shadow-cst_lg border-muted rounded-b-full rounded-tr-full absolute"></span>
              <span
                class="transform rotate-105 animate-pulse top-15 -right-2 w-8 h-6 bg-primary border-1.5 shadow-cst_lg border-muted rounded-b-full rounded-tr-full absolute"></span>
              <span
                class="transform rotate-180 animate-pulse right-6 w-8 h-6 bg-primary border-1.5 shadow-cst_lg border-muted rounded-b-full rounded-tr-full absolute"></span>
              <span
                class="transform -rotate-90 right-2 animate-pulse bottom-2 w-8 h-6 bg-primary border-1.5 shadow-cst_lg border-muted rounded-b-full rounded-tr-full absolute"></span>
              <span
                class="transform rotate-105 animate-pulse right-14 w-8 h-6 bg-primary border-1.5 shadow-cst_lg border-muted rounded-b-full rounded-tr-full absolute"></span>
            </div>
          </div>
        </div>
      </div>
      <div class="px-2 mt-8 w-full md:mt-12">
        <div class="flex flex-row justify-between items-center space-x-8">
          <div class="flex flex-wrap w-full">
            <div class="flex w-full md:w-1/2 h-512 lg:h-544 md:pr-2">
              <div class="flex flex-col space-y-0 w-full">
                <div class="w-full h-224 lg:h-384">
                  <img src="../assets/images/getviral-ml.png"
                       class="overflow-hidden w-full h-full" alt="GetViral Image">
                </div>
                <div class="flex flex-col justify-center items-center p-8 rounded-lg border-t-0 border-1 bg-secondary h-288">
                  <div class="flex flex-col justify-center items-center">
                    <div class="uppercase"><i class="font-bold fas fa-project-diagram text-secondary"></i>&nbsp;GetViral</div>
                    <div class="overflow-hidden mt-2 overflow-ellipsis">GetViral is a social campaign platform for getting users the required audience on their various social
                      media platforms. There are mainly two set of users, the advertisers and publishers.
                    </div>
                  </div>
                  <div class="py-2">
                    <ul class="flex flex-row flex-wrap justify-between items-center space-x-2 text-sm opacity-50 md:text-base lg:space-x-4">
                      <li>jQuery</li>
                      <li>HTM5</li>
                      <li>CSS3</li>
                      <li>Javascript</li>
                      <li>Laravel</li>
                    </ul>
                  </div>
                  <div class="flex justify-between items-center pt-3 space-x-4 text-black">
                    <div class="py-1 px-3 w-20 h-8 rounded ring-2 cursor-pointer bg-btn-primary ring-active hover:bg-secondary hover:text-primary hover:opacity-50">
                      <a :href="`https://getviral.ml/`" target="_blank"><i
                      class="fas fa-eye"></i> Site </a>
                    </div>
                    <div class="py-1 px-3 w-20 h-8 rounded ring-2 cursor-pointer bg-btn-secondary ring-active hover:bg-secondary hover:text-gold hover:opacity-50">
                      <a :href="`https://github.com/gblend/getviral`" target="_blank"><i
                      class="fab fa-github-square"></i> Code </a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="relative h-552 lg:h-608 left-1.5 md:mt-12 lg:mt-12 hidden md:block">
                <div class="flex absolute top-0 bottom-0 flex-col my-auto border-l-2 border-gold md:-top-12">
                  <i class="absolute -left-2 text-xs animate-ping fas fa-circle text-secondary md:mt-48 lg:top-16"></i>
                  <i class="absolute -left-2 text-sm fas fa-circle text-secondary md:mt-48 lg:top-16"></i>
                </div>
              </div>
            </div>
            <div class="flex mt-8 w-full md:w-1/2 h-512 lg:h-544 md:mt-0 md:pl-2">
              <div class="flex flex-col w-full">
                <div class="w-full h-224 lg:h-384">
                  <img src="../assets/images/personalizedwineng.png"
                       class="overflow-hidden w-full h-full resize" alt="Mock Image">
                </div>
                <div class="flex flex-col justify-center items-center p-8 rounded-lg border-t-0 border-1 h-288 bg-secondary">
                  <div class="flex flex-col justify-center items-center">
                    <div class="font-bold uppercase"><i class="font-bold fas fa-project-diagram text-secondary"></i>&nbsp;PersonalizedWine</div>
                    <div class="overflow-hidden mt-2 overflow-ellipsis">A web application that is built to make the process of booking/ordering for wine customization and
                      branding seamlessly.</div>
                  </div>
                  <div class="py-2">
                    <ul class="flex flex-row flex-wrap justify-between items-center space-x-2 text-sm opacity-50 md:text-base lg:space-x-4">
                      <li>PHP</li>
                      <li>HTML</li>
                      <li>CSS3</li>
                      <li>Javascript</li>
                      <li>Bootstrap4</li>
                      <li>jQuery</li>
                    </ul>
                  </div>
                  <div class="flex justify-between items-center pt-3 space-x-4 text-black">
                    <div class="py-1 px-3 w-20 h-8 rounded ring-2 cursor-pointer bg-btn-primary ring-active hover:bg-secondary hover:text-primary hover:opacity-50">
                      <a :href="`https://personalizedwineng.com/`" target="_blank">
                      <i
                      class="fas fa-eye"></i> Site</a>
                    </div>
                    <div class="py-1 px-3 w-20 h-8 rounded ring-2 cursor-pointer bg-btn-secondary ring-active hover:bg-secondary hover:text-gold hover:opacity-50">
                      <a :href="`https://github.com/otjake/personalizedwine`" target="_blank"><i
                      class="fab fa-github-square"></i> Code </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="flex flex-row justify-between items-center space-x-8">
          <div class="flex flex-wrap w-full">
          <div class="flex mt-8 w-full md:w-1/2 h-512 lg:h-544 md:mt-20 lg:mt-40 md:pr-2">
            <div class="flex flex-col w-full">
              <div class="w-full h-224 lg:h-384">
                <img src="../assets/images/users-base.png"
                     class="overflow-hidden w-full h-full resize" alt="Mock Image">
              </div>
              <div class="flex flex-col justify-center items-center p-8 rounded-lg border-t-0 border-1 h-288 bg-secondary">
                <div class="flex flex-col justify-center items-center">
                  <div class="font-bold uppercase"><i class="font-bold fas fa-project-diagram text-secondary"></i>&nbsp;Random Users Base</div>
                  <div class="overflow-hidden mt-2 overflow-ellipsis">Ubase is a dashboard for accessing random users' information.
                    Ubase dashboard houses features such as searching users' directory by country, categories
                  </div>
                </div>
                <div class="py-2">
                  <ul class="flex flex-row flex-wrap justify-between items-center space-x-2 text-sm opacity-50 md:text-base lg:space-x-4">
                    <li>Vue Js</li>
                    <li>HTML5</li>
                    <li>CSS3</li>
                    <li>Javascript</li>
                    <li>Random User API</li>
                  </ul>
                </div>
                <div class="flex justify-between items-center pt-3 space-x-4 text-black">
                  <div class="py-1 px-3 w-20 h-8 rounded ring-2 cursor-pointer bg-btn-primary ring-active hover:bg-secondary hover:text-primary hover:opacity-50">
                    <a :href="`https://users-base.herokuapp.com/`" target="_blank"><i
                    class="fas fa-eye"></i> Site </a>
                  </div>
                  <div class="py-1 px-3 w-20 h-8 rounded ring-2 cursor-pointer bg-btn-secondary ring-active hover:bg-secondary hover:text-gold hover:opacity-50">
                    <a :href="`https://github.com/gblend/user-base`" target="_blank"><i
                    class="fab fa-github-square"></i> Code </a>
                  </div>
                </div>
              </div>
            </div>
            <div class="relative h-552 lg:h-608 left-1.5 md:-mt-10 lg:mt-0 hidden md:block">
              <div class="flex absolute top-0 bottom-0 flex-col my-auto border-l-2 border-gold md:-top-12">
                <i class="absolute -left-2 text-xs animate-ping fas fa-circle text-secondary md:mt-72 lg:top-16"></i>
                <i class="absolute -left-2 text-sm fas fa-circle text-secondary md:mt-72 lg:top-16"></i>
              </div>
            </div>
          </div>
          <div class="flex mt-8 w-full md:w-1/2 h-512 lg:h-544 md:mt-20 lg:mt-40 md:pl-2">
            <div class="flex flex-col w-full">
              <div class="w-full h-224 lg:h-384">
                <img src="../assets/images/interbotic.png"
                     class="overflow-hidden w-full h-full resize" alt="Mock Image">
              </div>
              <div class="flex flex-col justify-center items-center p-8 rounded-lg border-t-0 border-1 h-288 bg-secondary">
                <div class="flex flex-col justify-center items-center">
                  <div class="font-bold uppercase"><i class="font-bold fas fa-project-diagram text-secondary"></i>&nbsp;Interbotic</div>
                  <div class="overflow-hidden mt-2 overflow-ellipsis">This is a minimal interactive chat bot, which can go on random conversations, jokes, gossips, humor,
                    etc.
                  </div>
                </div>
                <div class="py-2">
                  <ul class="flex flex-row flex-wrap justify-between items-center space-x-2 text-sm opacity-50 md:text-base lg:space-x-4">
                    <li>Python (Flask)</li>
                    <li>jQuery</li>
                    <li>CSS3</li>
                    <li>HTML</li>
                    <li>JavaScript</li>
                  </ul>
                </div>
                <div class="flex justify-between items-center pt-3 space-x-4 text-black">
                  <div class="py-1 px-3 w-20 h-8 rounded ring-2 cursor-pointer bg-btn-primary ring-active hover:bg-secondary hover:text-primary hover:opacity-50">
                    <a :href="`https://interbotic.herokuapp.com/`" target="_blank"><i
                    class="fas fa-eye"></i> Site </a>
                  </div>
                  <div class="py-1 px-3 w-20 h-8 rounded ring-2 cursor-pointer bg-btn-secondary ring-active hover:bg-secondary hover:text-gold hover:opacity-50">
                    <a :href="`https://github.com/gblend/InterBot`" target="_blank"><i
                    class="fab fa-github-square"></i> Code </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Projects'
}
</script>
